export default __webpack_public_path__ + "static/media/Capture.8f51a205.JPG";